import { createReducer } from 'redux-starter-kit';
import { fetchAllTaxRates, editTaxRate, cancelEditTaxRate, saveTaxRate, fetchDeleteTaxRate } from './taxUiActions';
import { selectRequest } from '../../../domain/requests/RequestReducer';


/**
 * A selector for finding the current edit state.
 * @param {object} state The redux state for the application.
 * @returns An object containing details about the package being edited.
 * @example const editState = selectEditState(state);
 */
export const selectEditState = state => state.via.ui.taxes.editState;

export const selectFetchTaxRatesRequest = (state) => {
  const requestId = state.via.ui.taxes.fetchTaxRatesRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

export const selectSubmitTaxRateRequest = (state) => {
  const requestId = state.via.ui.taxes.editState.submitTaxRateRequestId;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};

export const selectFetchDeleteTaxRateRequest = (state) => {
  const requestId = state.via.ui.taxes.fetchDeleteTaxRateRequest;
  if (!requestId) return null;

  return selectRequest(state, requestId);
};


const initialEditingState = {
  isEditing: false,
  date: null,
  submitTaxRateRequestId: null,
  validationMessages: ({
    title: '',
    messages: [],
    visible: false,
  }),
};

const taxesInitialState = {
  editState: initialEditingState,
  fetchTaxRatesRequestId: null,
  fetchDeleteTaxRateRequest: null,
  taxRates: null,
};

export default createReducer(taxesInitialState, {
  // Tax rates are being fetched from the server.
  [fetchAllTaxRates]: (state, action) => ({
    ...state,
    fetchTaxRatesRequestId: action.payload,
  }),

  // Deleting a tax rate on the server.
  [fetchDeleteTaxRate]: (state, action) => ({
    ...state,
    fetchDeleteTaxRateRequest: action.payload,
  }),

  // Tax rate is being saved.
  [saveTaxRate]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      submitTaxRateRequestId: action.payload,
    },
  }),

  // A tax rate is being edited.
  [editTaxRate]: (state, action) => ({
    ...state,
    editState: {
      ...state.editState,
      isEditing: true,
      date: action.payload,
    },
  }),

  // A tax rate is no longer being edited.
  [cancelEditTaxRate]: state => ({
    ...state,
    editState: {
      ...initialEditingState,
    },
  }),
});
